import { motion } from "framer-motion";
import { Reveal, Overline } from "./Reveal";
import { COLLECTIONS, WHATSAPP_URL, WHATSAPP_URL_EN } from "../../lib/content";
import { useLang } from "../../lib/i18n";

export const Collections = () => {
  const { lang, tr } = useLang();
  const f = (item, key) => (lang === "it" ? item[key] : item[key + "En"]);
  return (
    <section
      id="collezioni"
      data-testid="collections-section"
      className="relative bg-ad-surface py-24 md:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 md:mb-24">
          <Reveal>
            <Overline>{tr("Le Collezioni", "The Collections")}</Overline>
            <h2 className="mt-6 font-serif-display font-light text-4xl md:text-6xl leading-none tracking-tight text-white max-w-xl">
              {tr("Creazioni per lei, ", "Creations for her, ")}<span className="italic text-gold">{tr("e per lui", "and for him")}</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="font-sans-ui font-light text-white/60 max-w-sm md:text-right leading-relaxed">
              {tr(
                "Abiti da sposa d'alta moda, sartoria per lo sposo e proposte di cerimonia uomo. Tutto da vedere e provare, esclusivamente in Atelier.",
                "Haute couture wedding dresses, groom tailoring and men's ceremony wear. Everything to see and try on, exclusively at the Atelier."
              )}
            </p>
          </Reveal>
        </div>

        {/* Asymmetric gallery */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-6">
          {COLLECTIONS.map((c, i) => {
            const spans = [
              "md:col-span-7 md:row-span-2 h-[440px] md:h-[720px]",
              "md:col-span-5 h-[340px] md:h-[348px]",
              "md:col-span-5 h-[340px] md:h-[348px]",
            ];
            return (
              <Reveal
                key={c.title}
                delay={i * 0.12}
                className={spans[i]}
                data-testid={`collection-card-${i}`}
              >
                <a
                  href={tr(WHATSAPP_URL, WHATSAPP_URL_EN)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group relative block h-full w-full overflow-hidden"
                >
                  <motion.img
                    src={c.image}
                    alt={c.title}
                    className="h-full w-full object-cover"
                    initial={{ scale: 1 }}
                    whileHover={{ scale: 1.06 }}
                    transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/20 to-transparent" />
                  <div className="absolute inset-0 ring-1 ring-inset ring-white/10 group-hover:ring-gold/40 transition-colors duration-500" />
                  <div className="absolute inset-x-0 bottom-0 p-6 md:p-8">
                    <span className="font-sans-ui text-[10px] uppercase tracking-[0.3em] text-gold">
                      {f(c, "tag")}
                    </span>
                    <h3 className="mt-2 font-serif-display font-light text-3xl md:text-4xl text-white">
                      {f(c, "title")}
                    </h3>
                    <p className="mt-2 font-sans-ui font-light text-sm text-white/70 max-w-xs opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
                      {f(c, "text")}
                    </p>
                  </div>
                </a>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
